var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiyalGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Saudi Riyal",
    clipPath: "url(#clip0_9759_21786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.98031 8.07189C4.83755 8.38843 4.74318 8.73195 4.70703 9.09219L7.72808 8.44999C7.87084 8.13351 7.96513 7.78993 8.00135 7.42969L4.98031 8.07189Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.72672 6.52589C7.86948 6.20941 7.96385 5.86583 8 5.50559L5.6467 6.00609V5.04393L7.72665 4.60193C7.86941 4.28545 7.96378 3.94187 7.99993 3.58163L5.64663 4.08171V0.621496C5.28603 0.823962 4.96579 1.09347 4.70546 1.41136V4.28182L3.7643 4.48187V0.150879C3.4037 0.353274 3.08346 0.622849 2.82314 0.940745V4.68184L0.717277 5.12933C0.574519 5.44581 0.480083 5.78939 0.443859 6.14963L2.82314 5.644V6.85567L0.273276 7.39752C0.130518 7.71399 0.0361521 8.05758 0 8.41782L2.66899 7.85063C2.88626 7.80544 3.073 7.67699 3.19441 7.50021L3.68388 6.77454V6.7744C3.73469 6.69932 3.7643 6.60879 3.7643 6.5113V5.44396L4.70546 5.24391V7.16823L7.72665 6.52574L7.72672 6.52589Z",
    fill: "#7B7B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9759_21786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8.94116,
    fill: "white",
    transform: "translate(0 0.150879)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiyalGray);
export default __webpack_public_path__ + "static/media/riyalGray.303bf04e70410934129b31ca45aa513b.svg";
export { ForwardRef as ReactComponent };